const config = {
  API_BASE_URL: process.env.NODE_ENV === 'production' 
    ? 'https://langchainp1-bloggenrator.onrender.com'
    : 'http://127.0.0.1:8000'
};

export default config;
